import select from './select';

export default {
  select,
}